import { useForm } from "react-hook-form";
import FormInputs from "../FormInputs/FormInputs";
import "./ForgetPassword.css";
import {
  showErrorToast,
  showSuccessToast,
} from "../../utils/ToastMessages/ToastMessages";
import { forgetPassword } from "../../api/apiServices";
import React from "react";

interface Props{
  isForgetPass: any,
  setIsForgetPass: any
}

const ForgetPassword:React.FC<Props> = ({isForgetPass, setIsForgetPass}) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors: errors },
  }: any = useForm();

  const sendMailHandler = async (data: any) => {
    console.log("sendMailHandler-----___>>>");
    try {
      const bodyObject = {
        email: data.email,
      };

      const loginResponse: any = await forgetPassword(bodyObject);
      console.log("loginResponse-------->>>", loginResponse);
      if (!!loginResponse) {
        showSuccessToast(loginResponse.message);
        setValue("email", "");
        setIsForgetPass(!isForgetPass)
      } else {
        showErrorToast("Please Enter Valid Email!");
      }
    } catch (error: any) {
      showErrorToast(
        error?.response?.data?.error || "Please Enter Valid Email!"
      );
    }
  };

  return (
    <div className="forget-pass-container">
      <hr className="forget-pass-hr-line" />
      <h1 className="login-text">Forgot Password</h1>

      <form onSubmit={handleSubmit(sendMailHandler)}>
        <FormInputs
          maxLength={250}
          type={"email"}
          register={register}
          placeholder={"Email Address"}
          name={"email"}
          required={"Email is required"}
          pattern={/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/}
          message={"Enter a valid email address"}
          errors={errors}
          prevent={() => {}}
          disabled={false}
        />

        <div onClick={() => {}} className="forget-pass-new-button">
          <button type="submit">Send Verification Mail</button>
        </div>
      </form>
    </div>
  );
};

export default ForgetPassword;
